import { useEffect, useState } from 'react';
import './index.scss';
import { ANIMATIONS } from './constants';

type TProps = {
  isLoading: boolean;
};

export const PromptToImageLoader = ({
  isLoading,
}: TProps) => {
  const [animationState, setAnimationState] =
    useState<number>();

  const [timerId, setTimerId] = useState<NodeJS.Timeout>();
  const setAnimation = (
    index: number | undefined,
    endInTime?: number
  ) => {
    // clears previous timer to avoid unwanted behavior and memory use
    timerId && clearTimeout(timerId);
    setAnimationState(index);
    if (endInTime) {
      const timerId = setTimeout(() => {
        setAnimation(undefined);
      }, endInTime * 1000);
      setTimerId(timerId);
    } else if (index !== undefined) {
      const animationTime = ANIMATIONS[index]?.time;
      if (animationTime) {
        const timerId = setTimeout(() => {
          setAnimation(index + 1);
        }, animationTime * 1000);
        setTimerId(timerId);
      }
    }
  };

  useEffect(() => {
    if (isLoading) {
      setAnimation(0);
    } else if (!isLoading && animationState !== undefined) {
      if (animationState < 3)
        setAnimation(3, 2 /* animation for 2 seconds */);
      else setAnimation(undefined);
    }
  }, [isLoading]);

  const animation =
    animationState !== undefined
      ? ANIMATIONS[animationState]
      : undefined;
  return (
    <>
      {animation && (
        <div className="prompt-to-image-loader">
          <div className="header">
            <img src={animation.gif} />
            <span className="title">{animation.title}</span>
          </div>
          <div className="sub-heading">
            {animation.subTitle}
          </div>
          <div className="progress-bar">
            <div
              className="filled"
              style={{
                width: animation.progressBarWidth,
              }}></div>
          </div>
        </div>
      )}
    </>
  );
};
